import { Component, inject } from '@angular/core';
import { SnackbarService } from './snackbar.service';
import * as i0 from "@angular/core";
import * as i1 from "./snackbar.service";
import * as i2 from "primeng/toast";
import * as i3 from "primeng/api";
import * as i4 from "../icon-v2/icon.component";
import * as i5 from "@ngx-translate/core";
const _c0 = () => ({
  left: "80px",
  bottom: "40px",
  "z-index": "5000",
  width: "max-content",
  "max-width": "686px"
});
function SnackbarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "span", 2)(2, "div", 3)(3, "div", 4);
    i0.ɵɵelement(4, "geaui-icon-v2", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 6)(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 7);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "span", 8)(13, "geaui-icon-v2", 9);
    i0.ɵɵlistener("click", function SnackbarComponent_ng_template_1_Template_geaui_icon_v2_click_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clear());
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const message_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("p-inline-snackbar-message p-component p-inline-message-", message_r3.severity, "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("file", ctx_r1.getFile(message_r3.severity));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("p-toast-summary ", "gea-message-toast-summary-" + message_r3.severity || "unknown", "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, message_r3.summary), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 11, message_r3.detail));
  }
}
const FILES = new Map([['success', '24px_c-check'], ['info', '24px_c-info'], ['error', '24px_c-warning']]);
/**
 * this component shall be placed once in an application's dom.
 * thereafter you should add a snackbar via snackbar service to make it appear
 */
export class SnackbarComponent {
  snackbarService = inject(SnackbarService);
  key = '';
  constructor(snackbarService) {
    this.key = snackbarService.key;
  }
  getFile(severity) {
    return FILES.get(severity);
  }
  clear() {
    this.snackbarService.clear();
  }
  static ɵfac = function SnackbarComponent_Factory(t) {
    return new (t || SnackbarComponent)(i0.ɵɵdirectiveInject(i1.SnackbarService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SnackbarComponent,
    selectors: [["geaui-snackbar"]],
    decls: 2,
    vars: 4,
    consts: [["position", "bottom-left", 3, "key"], ["pTemplate", "message"], [1, "gea-snackbar-icon-container"], [1, "gea-snackbar-first-icon-container"], [1, "gea-snackbar-first-icon"], ["color", "white", "colorProp", "stroke", 3, "file"], [1, "gea-snackbar-text-container"], [1, "p-toast-detail"], [1, "gea-snackbar-close-button"], ["file", "16px_close", "color", "black", "colorProp", "stroke", 3, "click"]],
    template: function SnackbarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "p-toast", 0);
        i0.ɵɵtemplate(1, SnackbarComponent_ng_template_1_Template, 14, 13, "ng-template", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c0));
        i0.ɵɵproperty("key", ctx.key);
      }
    },
    dependencies: [i2.Toast, i3.PrimeTemplate, i4.IconComponent, i5.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SnackbarComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-snackbar',
      template: "<p-toast\n  [key]=\"key\"\n  [style]=\"{ left: '80px', bottom: '40px', 'z-index': '5000', width: 'max-content', 'max-width': '686px' }\"\n  position=\"bottom-left\">\n  <ng-template let-message pTemplate=\"message\">\n    <div class=\"p-inline-snackbar-message p-component p-inline-message-{{ message.severity }}\">\n      <span class=\"gea-snackbar-icon-container\">\n        <div class=\"gea-snackbar-first-icon-container\">\n          <div class=\"gea-snackbar-first-icon\">\n            <geaui-icon-v2 [file]=\"getFile(message.severity)\" color=\"white\" colorProp=\"stroke\"> </geaui-icon-v2>\n          </div>\n        </div>\n        <div class=\"gea-snackbar-text-container\">\n          <span class=\"p-toast-summary {{ 'gea-message-toast-summary-' + message.severity || 'unknown' }}\">\n            {{ message.summary | translate }}\n          </span>\n          <p class=\"p-toast-detail\">{{ message.detail | translate }}</p>\n        </div>\n        <span class=\"gea-snackbar-close-button\">\n          <geaui-icon-v2 (click)=\"clear()\" file=\"16px_close\" color=\"black\" colorProp=\"stroke\"></geaui-icon-v2>\n        </span>\n      </span>\n    </div>\n  </ng-template>\n</p-toast>\n"
    }]
  }], () => [{
    type: i1.SnackbarService
  }], null);
})();
